import FeedMenu from 'src/components/feed_menu/feed_menu.vue'
import { feedNames as names } from 'src/components/navigation/feed_store.js'
import { currentFeed, feedToReturnTo } from 'src/components/navigation/feeds.js'
import Popover from 'src/components/popover/popover.vue'

import { useInterfaceStore } from 'src/stores/interface'
import { useUsersStore } from 'src/stores/users.js'

// The phone bar's feeds button: the icon of the feed on screen, and the feed
// menu under it. On any other page it shows the last feed and goes back to it.
export default {
  components: { FeedMenu, Popover },
  computed: {
    feed() {
      return currentFeed(this.$route, names)
    },
    lastFeed() {
      return feedToReturnTo(
        useInterfaceStore().lastTimeline,
        !!useUsersStore().currentUser,
      )
    },
    // what the button shows
    shown() {
      return this.feed || currentFeed(this.lastFeed, names)
    },
    name() {
      return this.shown.labelRaw || this.$t(this.shown.label)
    },
  },
  methods: {
    back() {
      if (!this.feed) this.$router.push(this.lastFeed)
    },
  },
}
